<div class="success-dialog">
  <h1 matDialogTitle *ngIf="data.title">{{ data.title }}</h1>
  <mat-dialog-content>
    <p>{{ data.message }}</p>
  </mat-dialog-content>
</div>
